<template>
    <div class="col-md-12 flex-container">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="col-md-12">
            <div class="form-group" v-if="scanTourSuccess===''">
                <div class="h2">Pack tour</div>
                <div class="d-flex flex-column" style="max-width: 240px;">
                    <div class="bg-white border rounded-lg div-focus border-2">
                        <input type="text" v-if="scanTourSuccess===''"
                               autocomplete="none"
                               class="form-control border-0  shadow-none form-input scan-code"
                               placeholder="Scan tour"
                               @keyup="onScanTour($event)"
                               ref="scanTour"
                        >
                    </div>
                    <div class="mt-3" v-if="activeScanner === 'tour'">
                        <stream-barcode-reader @decode="onDecode" @loaded="onLoadedTourScanner"></stream-barcode-reader>
                    </div>
                </div>
            </div>

            <div v-if="scanTourError!==''">
                <div v-if="scanTourError==='Tour prepared'" class="scan alert alert-success">
                    <i>{{ scanTourError }}</i>
                </div>
                <div v-else-if="scanTourError==='Tour loaded'" class="scan alert alert-success">
                    <i>{{ scanTourError }}</i>
                </div>
                <div v-else class="scan alert alert-danger">
                    <i>{{ scanTourError }}</i>
                </div>
            </div>

            <div v-if="scanTourSuccess!==''">
                <div class="h3">
                    {{ showPrepareTour ? 'Prepare' : '' }}
                    {{ showLoadTour ? 'Load' : '' }}
                    {{ trip.driver }}
                </div>
                {{ trip.date }} <br/> <br/>

                <div v-if="!showPrepareTour && !showLoadTour">
                    <button class="btn btn-success" @click="prepareTour()"> Prepare tour</button>
                    <br/> <br/>

                    <button class="btn btn-success" @click="loadTour()"> Load tour</button>
                    <br/> <br/>

                    <a href="/settings/packing" class="btn btn-danger"> Back</a>
                </div>
                <div v-else>
                    <div class="form-group col-md-4">
                        <div
                            class="align-items-center">
                            <div class="bg-white border rounded-lg div-focus border-2">
                                <input type="text"
                                       autofocus
                                       autocomplete="none"
                                       class="form-control border-0  shadow-none form-input scan-code"
                                       placeholder="Scan colli"
                                       @keyup="onScanColli($event)"
                                       ref="scanCode"
                                >
                            </div>
                            <div class="mt-3" v-if="activeScanner === 'colli'">
                                <stream-barcode-reader @decode="onDecode" @loaded="onLoadedColliScanner"></stream-barcode-reader>
                            </div>
                            <br/>
                        </div>
                    </div>

                    <div v-if="scanCodeError!==''">
                        <div v-if="scanCodeError==='Colli already prepared'" class="scan alert alert-warning">
                            <i>{{ scanCodeError }}</i>
                        </div>
                        <div v-else-if="scanCodeError==='Colli already loaded'" class="scan alert alert-warning">
                            <i>{{ scanCodeError }}</i>
                        </div>
                        <div v-else class="scan alert alert-danger">
                            <i>{{ scanCodeError }}</i>
                        </div>
                    </div>
                    <div v-if="scanCodeSuccess!==''" class="scan alert alert-success">
                        Colli {{ colli.id }} found
                    </div>
                    <div v-if="scanCodeSuccess!==''" class="">
                        Booking: {{ colli.booking !== null ? `#B-${colli.booking.id}` : '' }} <br/>
                        Client: {{ colli.client.name }} <br/>
                        <!--                        Stop on tour: {{ colli.stopNumberOnTour + 1 }}/{{ colli.totalNumberOnTour }}<br/>-->
                    </div>

                    <div class="pt-3">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th class="border-right text-left">Stop</th>
                                    <th class="border-right text-left">Location</th>
                                    <th class="border-right text-left">Colli ID</th>
                                </tr>
                                </thead>
                                <tbody class="table-bordered">
                                <tr v-for="colli in associatedCollis"
                                    :class="scannedCodes.includes(colli.id) || !colli.location || colli.tripType === 1 || colli.bothTripTypes === 1? 'line-completed' : ''">
                                    <td>{{ colli.stopNumberOnTour }}</td>
                                    <td>{{ colli.tripType === 1 || colli.bothTripTypes === 1? 'AFHENTNING' : colli.location }}</td>
                                    <td>{{ colli.id }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!--                    <div>
                                            All collis for tour prepared/loaded
                                        </div>-->

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import StreamBarcodeReader from "./vue-barcode-reader/StreamBarcodeReader.vue";

export default {
    name: "PackGoods",
    components: {StreamBarcodeReader},
    props: {},
    data() {
        return {
            isSubmit: false,
            scanTourError: '',
            scanTourSuccess: '',
            scanLocationError: '',
            scanLocationSuccess: '',
            showTourResult: true,
            showPrepareTour: false,
            showLoadTour: false,

            scanCodeError: '',
            scanCodeSuccess: '',

            code: '',
            colli: {},
            trip: {},
            routes: {},
            associatedCollis: [],
            pickListOrders: [],
            showAllPreparedResult: false,
            loadingTour: false,
            loadingColli: false,
            scannedCodes: [],
            activeScanner: 'tour'
        }
    },
    methods: {
        onScanTour(event) {
            if (event !== null) {
                this.code = event.target.value;
            }
            setTimeout(() => {
                if (!this.loadingTour) {
                    this.loadingTour = true;
                    axios.get(`/scan-tour/${this.code}/${this.getScanType()}`)
                        .then(({data}) => {
                            if (data.message === 'empty') {
                                this.scanTourError = 'empty orders list'
                                this.scanTourSuccess = '';
                            } else if (data.message === 'loaded') {
                                this.scanTourError = `Tour ${this.code} already prepared`;
                                this.scanTourSuccess = '';
                            } else if (data.message === 'prepared') {
                                this.scanTourError = `Tour ${this.code} already loaded`
                                this.scanTourSuccess = '';
                            } else {
                                this.scanTourError = '';
                                this.scanTourSuccess = ' Success';
                                this.trip = data.data;
                                this.routes = data.routes;
                                this.pickListOrders = data.pickListOrders;
                                if (this.getScanType() === 0) {
                                    this.associatedCollis = data.collis;
                                }
                                for (const objId in this.associatedCollis) {
                                    const obj = this.associatedCollis[objId];
                                    const id = obj.id;
                                    if (this.associatedCollis[id]) {
                                        obj.stopNumberOnTour = this.pickListOrders[parseInt(this.associatedCollis[id]['tripId'])] + 1;
                                    }
                                }
                                const tmp = Object.values(this.associatedCollis);
                                tmp.sort((a, b) => parseInt(a.stopNumberOnTour) - parseInt(b.stopNumberOnTour));
                                this.associatedCollis = tmp;
                            }
                        }).catch((error) => {
                            console.log(error);
                            this.scanTourError = (error.response && error.response.data && error.response.data.message) ?
                                error.response.data.message :
                                'Error';
                            this.scanTourSuccess = '';
                        }).finally(() => {
                            this.loadingTour = false;
                        });
                }
            }, 500);
        },
        prepareTour() {
            this.showPrepareTour = true;
            this.onScanTour(null);
            this.activeScanner = 'colli';
        },
        loadTour() {
            this.showLoadTour = true;
            this.onScanTour(null);
            this.activeScanner = 'colli';
        },
        getScanType() {
            let type;
            if (this.showLoadTour) {
                type = 3;
            } else if (this.showPrepareTour) {
                type = 2;
            } else {
                type = 0;
            }
            return type;
        },
        onScanColli(event) {
            setTimeout(() => {
                if (!this.loadingColli) {
                    this.loadingColli = true;
                    axios.get(`/scan-colli/${this.code}/${event.target.value}/${this.getScanType()}`)
                        .then(({data}) => {
                            if (data.message === 'not found') {
                                this.scanCodeError = 'Colli not found';
                                this.scanCodeSuccess = '';
                                let audio = new Audio('/assets/beep-warning-6387.mp3');
                                audio.play();
                            } else if (data.message === 'wrong tour') {
                                this.scanCodeError = 'Colli not on tour';
                                this.scanCodeSuccess = '';
                                let audio = new Audio('/assets/beep-warning-6387.mp3');
                                audio.play();
                            } else if (data.message === 'prepared') {
                                this.scanCodeError = 'Colli already prepared';
                                this.scanCodeSuccess = '';
                                let audio = new Audio('/assets/beep-warning-6387.mp3');
                                audio.play();
                            } else if (data.message === 'loaded') {
                                this.scanCodeError = 'Colli already loaded';
                                this.scanCodeSuccess = '';
                                let audio = new Audio('/assets/beep-warning-6387.mp3');
                                audio.play();
                            } else {
                                this.scannedCodes.push(parseInt(event.target.value));
                                this.scanCodeError = '';
                                this.scanCodeSuccess = 'Success';
                                this.colli = data.data;
                                //this.colli.stopNumberOnTour = 111;
                                this.colli.totalNumberOnTour = Object.keys(this.pickListOrders).length;
                                this.onScanTour(null);
                                if (Object.keys(this.associatedCollis).length === 0) {
                                    this.showAllPreparedResult = true;
                                }
                                this.$refs.scanCode.value = '';
                            }
                        }).catch((error) => {
                            console.log(error);
                            this.scanCodeSuccess = '';
                            this.scanCodeError = (error.response && error.response.data && error.response.data.message) ?
                                error.response.data.message :
                                'Error';
                        }).finally(() => {
                            this.loadingColli = false;
                        });
                }
            }, 500);
        },
        validation() {
            this.isSubmit = true;
        },
        onDecode(value) {
            console.log(this.activeScanner);
            if (this.activeScanner === 'tour') {
                this.onDecodeTour(value);
            } else if (this.activeScanner === 'colli') {
                this.onDecodeColli(value);
            } else {
                console.log('Unknown scanner');
            }
        },
        onDecodeTour(value) {
            this.$refs.scanTour.value = value;
            const e = {target: {value: value}}
            this.onScanTour(e);
        },
        onDecodeColli(value) {
            this.$refs.scanCode.value = value;
            const e = {target: {value: value}};
            this.onScanColli(e);
        },
        onLoadedTourScanner() {
            console.log('Tour scanner is loaded');
        },
        onLoadedColliScanner() {
            console.log('Colli scanner is loaded');
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.scanTourSuccess === '') {
                this.$refs.scanTour.focus();
            }
        });
    },
}
</script>

<style>
.flex-container {
    height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.flex-item {
    background-color: tomato;
    padding: 5px;
    width: 20px;
    height: 20px;
    margin: 10px;
    line-height: 20px;
    color: white;
    font-weight: bold;
    font-size: 2em;
    text-align: center;
}

.scan-error {
    color: red;
}

.scan {
    margin-top: 10px;
    margin-left: 10px;
}

.line-completed {
    background-color: #81ff7a;
}
</style>
